(function () {
  'use strict';

  angular.module('ringbaPortal').component('polyglotParserForm', {
    bindings: {
      parsingPipeline: '<',
      showFullWidthOptions: '<',
      isReadOnly: '<',
      enableScrolling: '<',
      setFilterContainerObj: '&',
      useParsingValidation: '<?',
      parsingObjectForValidation: '=?',
    },
    controller: PolyglotParserFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/polyglot-parser-form/polyglot-parser-form.view.html'
  });

  function PolyglotParserFormController(
    _,
    isMobileDevice,
    mediaQueryService,
    $scope
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.isArray = angular.isArray;

    vm.addParsingStep = addParsingStep;
    vm.removeParsingStep = removeParsingStep;

    function onInit() {
      vm.isMobileView = isMobileDevice && mediaQueryService.evaluateMediaQuery('xs');

      vm.responseParserTypes = [{
        name: 'JPath',
        value: 'jpath'
      },
      {
        name: 'XPath',
        value: 'xpath'
      },
      {
        name: 'Regular Expression',
        value: 'regex'
      },
      {
        name: 'JavaScript',
        value: 'javascript'
      }
      ];

      if (vm.parsingPipeline.length && vm.useParsingValidation) {
        vm.parsingObjectForValidation.text = vm.parsingPipeline[0].Value;
        $scope.$emit('onParsingValidationChange');
      }
    }

    function addParsingStep() {
      vm.parsingPipeline.push({parserType:vm.newParseStep.parserType,
        Value: vm.newParseStep.Value
      });

      if (vm.useParsingValidation) {
        vm.parsingObjectForValidation.text = vm.newParseStep.Value;
        $scope.$emit('onParsingValidationChange');
      }

      delete vm.newParseStep.parserType;
      delete vm.newParseStep.Value;
    }

    function removeParsingStep(parseStep) {
      const index = vm.parsingPipeline.indexOf(parseStep);

      if(index > -1) {
        vm.parsingPipeline.splice(index, 1);
      }

      if (vm.useParsingValidation && !vm.parsingPipeline.length) {
        vm.parsingObjectForValidation.text = '';
        $scope.$emit('onParsingValidationChange');
      }
    }
  }
})();
